// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"797877ef","311":"ad1ff3df"}[chunkId] + ".chunk.css";
};